<template>
  <div id="careers-content">
    <div class="jumbotron">
      <div class="jumbotron-background"></div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h2><small>Careers at NIC</small></h2>
            <h1 class="jumbotron-title">Join our Team</h1>
            <div class="row">
              <div class="col-md-8">
                <h2>Recruiting for careers in technology innovation</h2>
                <p class="lead">Headquartered on 18 acres in Southern Oregon, NIC operates several facilities that include
                  nearly 100,000 square feet of manufacturing space, a state-of-the-art polymer production plant, training
                  facilities, robotics integration group, Research & Development, and all our business support services.
                  We take pride in manufacturing our products in the United States.
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="hero-image-container">
              <img src="/img/nic-industries-careers.jpg" alt="" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="careers-detail" class="container">
      <div id="values" class="section">
        <h2 class="title text-center">What do we <span>value?</span></h2>
        <div class="row">
          <div class="item-group">
            <div class="item col-sm-4">
              <div class="panel panel-default">
                <div class="panel-body">
                  <h4><i class="fa fa-handshake-o" aria-hidden="true"></i>&nbsp;Integrity</h4>
                  <p>An uncompromisable commitment to integrity is paramount to long-term success; victory without it is
                    hollow and short-lived.</p>
                </div>
              </div>
            </div>
            <div class="item col-sm-4">
              <div class="panel panel-default">
                <div class="panel-body">
                  <h4><i class="fa fa-cogs" aria-hidden="true"></i>&nbsp;Development</h4>
                  <p>Continuous professional growth of our team is crucial to maximizing excellence, innovation, and
                    organizational resilience.</p>
                </div>
              </div>
            </div>
            <div class="item col-sm-4">
              <div class="panel panel-default">
                <div class="panel-body">
                  <h4><i class="fa fa-trophy" aria-hidden="true"></i>&nbsp;Stewardship</h4>
                  <p>We must be good stewards of the trust we have earned from our customers, employees, and vendors.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="item-group">
            <div class="item col-sm-4">
              <div class="panel panel-default">
                <div class="panel-body">
                  <h4><i class="fa fa-rocket" aria-hidden="true"></i>&nbsp;Technology</h4>
                  <p>Advancing core technologies through prioritized, focused investment is vital to the success and
                    endurance of our company and our customers.</p>
                </div>
              </div>
            </div>
            <div class="item col-sm-4">
              <div class="panel panel-default">
                <div class="panel-body">
                  <h4><i class="fa fa-users" aria-hidden="true"></i>&nbsp;Investment</h4>
                  <p>Investment of all company resources must be made with calculated planning to achieve an intentional
                    outcome.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="benefits" class="section">
        <h2 class="title text-center">What's in it for <span>you?</span></h2>
        <div class="row">
          <div class="item-group">
            <div class="item col-sm-12">
              <div class="panel panel-default">
                <div class="panel-body">
                  Competitive wages, generous healthcare benefits package, monthly performance bonus, and the
                  opportunity to build your career with a global leader!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="bamboo" class="section">
        <h2 class="title text-center">Available <span>Positions</span></h2>
        <div class="row">
          <div class="item-group">
            <div class="item col-sm-12">
              <div class="panel panel-default">
                <div class="panel-body">
                  <p>
                    Get the real-world experience you need to start or continue the career you've always wanted. Join our
                    team of innovators and achievers! At
                    NIC Industries, Inc. we are continuously seeking exceptional talent in:
                  </p>
                  <ul>
                    <li>I.T.</li>
                    <li>Marketing</li>
                    <li>Social media</li>
                    <li>Sales</li>
                    <li>Finance</li>
                  </ul>
                  <p>
                    If you are passionate about making an impact, driving growth, and being part of a dynamic,
                    forward-thinking company, we want to hear from
                    you. Explore exciting opportunities to unleash your potential and shape the future with us.
                  </p>
                  <p>
                    <a href="mailto:careers@nicindustries.com"><strong>careers@nicindustries.com</strong></a>
                  </p>
                  <p>Thank you,</p>
                  <p>Human Resources</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default">
              <div class="panel-body">
                <div id="BambooHR" data-domain="nicindustries.bamboohr.com" data-version="1.0.0" data-departmentId="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'careers',

  mounted() {
    let bambooScript = document.createElement('script')
    bambooScript.setAttribute('src', 'https://nicindustries.bamboohr.com/js/embed.js')
    document.head.appendChild(bambooScript)
  }
};
</script>

<style scoped lang="scss">
$alternate: #f69422;
$white: #fafafa;
$highlight: #3a3a39;
$font: #393939;

#careers-content {
  .jumbotron {
    position: relative;
    overflow: hidden;
    background-color: #e6e8e8;
    margin: 0;

    &-background {
      position: absolute;
      left: 100%;
      bottom: 50%;
      margin: auto;
      overflow: hidden;
      height: 3000px;
      width: 3000px;
      max-width: 3000px;
      max-height: 3000px;
      background-image: radial-gradient($white, $highlight);
      transform: translateX(-85%) rotate(15deg);
      z-index: 1;
    }

    .container {
      position: relative;
      z-index: 2;

      h1 {
        position: relative;
        color: $font;
        font: 800 350%/1.4 "Open Sans", sans-serif;
        width: max-content;
        display: inline;
      }

      h1::before {
        content: "";
        position: absolute;
        width: 110%;
        height: 100%;
        background: linear-gradient(to bottom, transparent 60%, $alternate 60%);
        background-repeat: no-repeat;
        z-index: -1;
        left: -5%
      }

      h1::selection {
        -webkit-text-stroke: 4px $white;
        color: transparent;
      }

      p {
        margin: 3% 0;
      }
    }

    .hero-image-container {
      padding: 0 1%;
      border-left: 10px solid $alternate;

      img {
        max-height: 100%;
        border-radius: 4px;
        margin: 0 auto;
        width: 100%;
      }
    }
  }

  #careers-detail {
    padding-bottom: 3%;

    .section {
      padding: 3% 0;

      .row {
        margin-top: 1%;
      }

      .title {
        font-size: 3rem;
        font-weight: bold;
      }

      .title span {
        color: $alternate;
      }
    }

    #benefits,
    #values {
      .item-group {
        display: flex;
      }

      .item {
        display: flex;

        .panel-default {
          width: 100%;

          .panel-body {
            blockquote {
              font-size: 1.5rem;
              border-color: $alternate;

              footer {
                background-color: transparent;
              }
            }

            h4 {
              font-weight: 700;
              letter-spacing: 1px;
              margin: auto;
              padding-bottom: 10px;

              &::before {
                background-color: $highlight;
                content: '';
                display: block;
                height: 3px;
                width: 75px;
                margin-bottom: 5px;
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .jumbotron {
      h1::before {
        display: none;
      }
    }

    #careers-detail {

      #benefits,
      #values {

        .item-group {
          display: inherit;
        }
      }
    }
  }
}
</style>